import React, { FC } from 'react'
import { GatsbyLinkProps, Link } from 'gatsby'
import { Locale } from './Locale'
import { LocalPath } from './LocalPath'
import { useLocalePath } from './useLocalePath'

export interface LocaleLinkProps extends Omit<GatsbyLinkProps<any>, 'to'> {
  to: LocalPath | string
  locale?: Locale
}

export const LocaleLink: FC<LocaleLinkProps> = ({ to, locale, children, ...rest }) => {
  const path = useLocalePath(to, locale)

  return (
    // @ts-ignore
    <Link to={path} {...rest}>
      {children}
    </Link>
  )
}
